import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { Checkbox } from '../common/Checkbox';
import { RadioButton } from '../common/RadioButton';
import { ActionButton } from '../common/petCloud/ActionButton';
import {
  DISCLOSURE_URL,
  ECONSENT_URL,
  INSURANCE_FRAUD_URL,
} from './petDemographics.constants';

import styles from './Agreements.module.css';

const Agreements = ({
  declarations = { },
  onGoBackClick = () => { },
  onSubmit = () => { },
}) => {
  const { t } = useTranslation('petDemos');

  // Acknowledgment checkbox is required but doesn't map to backend
  const [acknowledgeChecked, setAcknowledgeChecked] = useState(false);
  // eConsent value maps to "agree" field in backend
  const [eConsentAgreed, setEConsentAgreed] = useState(declarations.agree);

  const handleEConsentAgree = () => setEConsentAgreed(true);
  const handleEConsentDisagree = () => setEConsentAgreed(false);

  const isSubmitDisabled = !acknowledgeChecked || eConsentAgreed === null;

  const handleSubmit = () => {
    if (acknowledgeChecked && eConsentAgreed !== null) {
      onSubmit({
        agree: eConsentAgreed,
        caslAgree: acknowledgeChecked,
      });
    }
  };

  // children are injected by Trans component
  const LinkComponent = ({ children, url = '' }) => (
    <a
      className={styles.linkButton}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.titleSection}>
          <h1 className={styles.title}>{t('agreements.title')}</h1>
        </div>

        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>
            {t('agreements.acknowledgeTitle')}
          </h4>

          <p className={styles.sectionDescription}>
            <Trans
              components={{ bold: <LinkComponent url={INSURANCE_FRAUD_URL} /> }}
              i18nKey="agreements.acknowledgeDescription"
              ns="petDemos"
            />
          </p>

          <div className={styles.checkboxContainer}>
            <Checkbox
              checked={acknowledgeChecked}
              className={styles.checkbox}
              id="acknowledge-checkbox"
              label={t('agreements.agree')}
              onChange={setAcknowledgeChecked}
            />
          </div>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            {t('agreements.eConsentTitle')}
          </h2>

          <p className={styles.sectionDescription}>
            <Trans
              components={{ bold: <LinkComponent url={ECONSENT_URL} /> }}
              i18nKey="agreements.eConsentDescription"
              ns="petDemos"
            />
          </p>

          <div className={styles.radioContainer}>
            <RadioButton
              blue
              checked={eConsentAgreed === true}
              className={styles.noMargin}
              id="econsent-agree"
              name="econsent"
              onChange={handleEConsentAgree}
            >
              <span className={styles.radioLabel}>{t('agreements.agree')}</span>
            </RadioButton>

            <RadioButton
              blue
              checked={eConsentAgreed === false}
              className={styles.noMargin}
              id="econsent-disagree"
              name="econsent"
              onChange={handleEConsentDisagree}
            >
              <span className={styles.radioLabel}>
                {t('agreements.disagree')}
              </span>
            </RadioButton>
          </div>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            {t('agreements.disclosureTitle')}
          </h2>

          <p className={styles.sectionDescription}>
            <Trans
              components={{ bold: <LinkComponent url={DISCLOSURE_URL} /> }}
              i18nKey="agreements.disclosureDescription"
              ns="petDemos"
            />
          </p>
        </div>

        <div className={styles.buttonsContainer}>
          <ActionButton
            className={styles.cancelButton}
            isSecondaryButton
            noMargin
            onClick={onGoBackClick}
            title={t('agreements.back')}
          />

          <ActionButton
            className={styles.submitButton}
            disabled={isSubmitDisabled}
            noMargin
            onClick={handleSubmit}
            title={t('agreements.submit')}
          />
        </div>
      </div>
    </div>
  );
};

export { Agreements };
